import {observer} from 'mobx-react-lite'
import React, {useEffect, useMemo, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Sync} from '@client/sync'
import {Badge} from '@components/common/base/badge'
import {IconButton} from '@components/common/base/buttons'
import {getHub} from '@components/message-forwarding/utils/get-hub'
import {getChats} from '@components/right-panel/task-chat-list/get-chats'
import {useNotificationSettings} from '@containers/hooks'
import {getLastMentionMessage, getLastSeenMessageTime} from '@extensions/chat'
import {globals} from '@extensions/globals-base'
import {useChatStore} from '../chat-store'

const TwMentionContainer = tw.div`
  absolute
  top-[-41px]
  right-8
`

const TwMentionWrapper = tw.div`
  border-1
  border-line-base
  border-solid
  bg-background-primary
  rounded-50

  flex
  items-center
  justify-center
  min-w-32
  min-h-32

  relative
`

const TwBadgeContainer = tw.div`
  absolute
  top-[-8px]

  w-full

  flex
  items-center
  justify-center
`

export const MentionButton = observer(() => {
  const [state] = useChatStore()
  const hubId = state?.hub?.id
  if (!hubId) {
    return null
  }

  return <MentionButtonBase />
})

export const MentionButtonBase = observer(() => {
  const [state, store] = useChatStore()
  const [mentionsAmount, setMentionsAmount] = useState(0)
  const hubId = state?.hub?.id
  const hub = useMemo(() => (hubId ? getHub(hubId).hub : undefined), [hubId])

  const notificationSettings = useNotificationSettings()
  useEffect(() => {
    if (!hub) {
      return
    }

    const box = Sync.getCurrentSandbox()
    const chat = getChats(box, undefined, true, notificationSettings).find(
      c => c.chatId === hubId
    )
    if (!chat) {
      return
    }

    const lastSeen = getLastSeenMessageTime(state.hub)
    const startFrom = Math.max(state.lastSeenScrolled, lastSeen)
    const amount = chat.getNewMentionsAmount(startFrom)
    setMentionsAmount(amount)
  }, [
    hubId,
    hub,
    state.lastSeenScrolled,
    state.messagesList,
    notificationSettings
  ])

  if (!hub || !mentionsAmount) {
    return null
  }

  const onAtClick = () => {
    const box = Sync.getCurrentSandbox()
    const hub = box.getHub(hubId)
    if (!hub) {
      return
    }

    const userId = globals.currentUserId
    const lastSeen = getLastSeenMessageTime(hub)
    const startFrom = Math.max(state.lastSeenScrolled, lastSeen)
    const msg = getLastMentionMessage(hub, userId, startFrom)

    if (msg) {
      store.scrollToTimestamp(msg.timestamp)
    } else {
      store.scrollBottom()
    }
  }

  return (
    <TwMentionContainer>
      <TwMentionWrapper>
        <TwBadgeContainer>
          <Badge type="rounded" unread>
            {mentionsAmount}
          </Badge>
        </TwBadgeContainer>
        <IconButton icon={'IconAt'} color={'grey'} onClick={onAtClick} />
      </TwMentionWrapper>
    </TwMentionContainer>
  )
})
